import React from 'react'
import { useNavigate } from 'react-router-dom'

import { MemberListRow } from '@/types/User'

export function MobileMemberCard({ member }: { member: MemberListRow }) {
  const navigate = useNavigate()

  function routeToMember() {
    navigate(`/members/${member.id}`, { relative: 'path' })
  }

  return (
    <div
      className="mb-4 w-full overflow-hidden rounded-md border border-border-primary p-4 shadow-md"
      onClick={routeToMember}
      onKeyDown={() => {}}
      role="presentation"
    >
      <p className="mb-1 text-p-sm" style={{ fontWeight: 'bold' }}>
        {member?.fullName || ' '}
      </p>

      <p className="mb-1 font-light text-p-sm text-grey-500">{member.email}</p>
      <p className="font-light text-p-sm capitalize text-secondary">{member.phone}</p>
    </div>
  )
}
